<template lang="pug">
	div
		h5.mb-3 Реквизиты организации

		transition(name="fade")

			b-alert.mb-3(v-if="account.data.company_file" show variant='success') Файл с реквизитами организации получен.

			div(v-else)
				b-card-text.mb-3 Для ускорения процесса составления договора и выставления счёта Вы можете отправить файл с реквизитами Вашей организации:

				b-card-text

					b-form.mb-3(@submit='onSubmit')

						b-alert(:show='alert.error.hideCountDown' fade dismissible variant='danger' @dismissed='alert.error.hideCountDown=0' @dismiss-count-down='countDownChanged($event, "error")')
							h4.alert-heading Error!
							p {{ alert.error.message }}

						b-alert.mb-3(:show='alert.success.hideCountDown' fade dismissible variant='success' @dismissed='alert.success.hideCountDown=0' @dismiss-count-down='countDownChanged($event, "success")')
							p {{ alert.success.message }}
						div
							b-form-file.mr-3(v-model="company_file" id="company_file" name="company_file" placeholder='Реквизиты организации' drop-placeholder='Drop file here...' style="width:auto;")
							b-button(variant='primary' type='submit' :disabled="myParticipant.isFetching || myParticipant.data.company_file") Отправить

		h5.mb-3 Документы на оплату:

		div.mb-3(v-if="!myParticipant.data.contract_file && !myParticipant.data.bill_file && !myParticipant.data.act")
			b-alert(show) На данный момент для Вас формируются документы на оплату. Пожалуйста ожидайте обновления.
		div(v-else)

			div.g-between-center.mb-3
				div Договор/Договор-счет
				b-button(v-if="myParticipant.data.contract_file" :href="myParticipant.data.contract_file" target="_blank" download) скачать
				span(v-else) Формируется...

			div.g-between-center.mb-3
				div Счет
				b-button(v-if="myParticipant.data.bill_file" :href="myParticipant.data.bill_file" target="_blank") скачать
				span(v-else) Формируется...

			div.g-between-center.mb-3
				div Акт
				b-button(v-if="myParticipant.data.act" :href="myParticipant.data.act" target="_blank") скачать
				span(v-else) Формируется...

</template>

<script>
	import {mapActions, mapState} from 'vuex';


	export default {
		name: 'p-option',
		data: () => ({
			alert: {
				success: { hideSecs:5, hideCountDown:0, message: 'Файл с реквизитами организации получен.' },
				error: { hideSecs: 5, hideCountDown: 0, message: 'Произошла ошибка!' }
			},
			company_file: null
		}),
		computed: {
			...mapState(['myParticipant', 'account']),
		},
		methods: {
			...mapActions(["patchAccount","getAccount"]),

			countDownChanged(hideCountDown, event) {
				this.alert[event].hideCountDown = hideCountDown;
			},
			successFormHandler(){ return this.showAlert(this.alert.success.message, 'success') },
			errorFormHandler(error){ return this.showAlert(error.non_field_errors ? error.non_field_errors[0] : '', 'error') },
			getData(){
				const formData = new FormData();
				formData.append('company_file', this.company_file);
				return formData;
			},
			onSubmit(e) {
				e.preventDefault();
				this.$store.dispatch("patchAccount", this.getData())
					.then( () => {
						this.successFormHandler();
						this.$store.dispatch('getAccount');
					})
					.catch( error => this.errorFormHandler(error) );
			},
			showAlert(message, event) {
				this.alert[event].hideCountDown = this.alert[event].hideSecs;
				this.alert[event].message = message ? message : this.alert[event].message;
			},
		},
	}
</script>
